import './Modal.scss'

import AppLinkButton from '../buttons/AppLinkButton';
import AppLoading from '../AppLoading';
import Modal from 'react-bootstrap/Modal';

function InformativeModal({ show, closeModal, title, isLoading = false, children, textBtnCancel = 'OK' }) {

    return (
        <Modal className='hallapp-modal custom-backdrop' centered show={show} fullscreen={false} onHide={() => closeModal()}>
            <Modal.Header style={{ border: 'none', padding: '25px' }} closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    {children}
                </div>
            </Modal.Body>
            <Modal.Footer style={{ border: 'none', padding: '25px' }}>

                {
                    isLoading ? <AppLoading /> : <AppLinkButton width='100%' name={textBtnCancel} onClick={() => closeModal()} />
                }
            </Modal.Footer>
        </Modal>
    );
}

export default InformativeModal;